import { Badge, Table, Alert } from 'react-bootstrap';
import {
  DialogTitle,
  Grid,
  Paper,
  createMuiTheme,
  makeStyles,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { getVehicleDetail } from 'app/features/karloVehicles/karloVehiclesSlice';
import { makeSelectKarloVehiclesDetails } from 'app/features/karloVehicles/selectors';

import Modal from '../../../../components/Modal';
import ActiviesProgram from '../../../../components/ActiviesProgram';
import { closeModals } from 'app/features/modals/modalsSlice';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';

const theme = createMuiTheme({
  overrides: {
    MuiTooltip: {
      tooltip: {
        fontSize: '1em',
        color: 'lightblue',
        backgroundColor: 'green',
      },
    },
  },
});

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    textAlign: 'left',
    color: theme.palette.text.secondary,
  },
  paperTarjeta: {
    textAlign: 'left',
    marginTop: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  divider: {
    width: '100%',
  },
  title: {
    textAlign: 'left',
    color: '#1c1c1c',
  },
  content: {
    textAlign: 'left',
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    margin: theme.spacing(1, 1, 1, 1),
  },
  menu: {
    width: 200,
  },
  margin: {
    margin: theme.spacing(1),
  },
  list: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    // backgroundColor: theme.palette.background.paper,
  },
  inline: {
    display: 'inline',
  },
  bigContainer: {
    display: 'flex',
  },
  leftContainer: {
    flexDirection: 'column',
  },
  rightContainer: {
    flexDirection: 'column',
  },
  item: {
    textAlign: 'left',
    justifyContent: 'space-between',
  },
  paperOrden: {
    width: '100%',
    textAlign: 'left',
    justifyContent: 'space-between',
    color: theme.palette.text.secondary,
  },
  paperCliente: {
    width: '100%',
    textAlign: 'left',
    marginTop: theme.spacing(2),
    justifyContent: 'space-between',
    color: theme.palette.text.secondary,
  },
  paperOps: {
    width: '100%',
    margin: theme.spacing(2, 0),
    justifyContent: 'space-between',
    color: theme.palette.text.secondary,
  },
  paperUrl: {
    width: '100%',
    justifyContent: 'space-between',
    color: theme.palette.text.secondary,
  },
  itemBlock: {
    display: 'flex',
  },
  item1: {
    textAlign: 'left',
  },
  item2: {
    textAlign: 'center',
  },
  rightIcon: {
    marginLeft: theme.spacing(1),
  },
  tableTitle: {
    fontWeight: 401,
  },
  tables: {
    width: '100%',
  },
  media: {
    height: 60,
    width: '100%',
    position: 'relative',
  },
  feedBackStatus: {
    width: '50px',
    height: 'auto',
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: '30px',
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  inputs: {
    marginTop: theme.spacing(1),
  },
  select: {
    margin: theme.spacing(1, 0, 1, 0),
  },
}));

function VehicleDetail(props) {
  const classes = useStyles();
  // const { closeModals, vehicleDetail } = props;
  const { vehicleDetail } = props;
  // const { vehicleDetail } = [];
  const [vehicleData, setVehicleData] = useState([]);
  const [agenciesData, setAgenciesData] = useState([]);
  const [userData, setUserData] = useState([]);
  const [logsData, setLogsData] = useState([]);
  const [appointmentsData, setAppointmentsData] = useState([]);

  useEffect(() => {
    if (vehicleDetail == null) {
      console.log('es nill');
    } else {
      if (Array.isArray(vehicleDetail.ordersService)) {
        const cleanData = vehicleDetail.ordersService.map((event) => {
          return {
            text: event.dmsId,
            date: event.dateCreated,
            type: event.orderType,
          };
        });
        console.log('cleanData ', cleanData);
        setLogsData(cleanData);
      }
      if (Array.isArray(vehicleDetail.allServiceAppointments)) {
        const cleanDataDos = vehicleDetail.allServiceAppointments.map(
          (event) => {
            return {
              text: event.type + ' / ' + event.description,
              date: event.date,
              type: 'serviceAppt',
            };
          },
        );
        console.log('cleanDataDos ', cleanDataDos);
        setAppointmentsData(cleanDataDos);
      }
      setVehicleData(vehicleDetail);
      setAgenciesData(
        vehicleDetail.agency == null ? [] : vehicleDetail.agency,
      );
      setUserData(
        vehicleDetail.user == null ? [] : vehicleDetail.user,
      );
    }
  }, [vehicleDetail]);

  useEffect(() => {
    props.setLeftSideComponent(
      <div className="kt-subheader__main">
        <div>
          <h3 className="kt-subheader__title">Detalle Vehiculo</h3>
        </div>
      </div>,
    );
    let data = {
      karloID: props.match.params.id,
    };
    props.getVehicleDetail(data);
  }, []);

  function handleCloseModals() {
    closeModals();
  }

  const renderAppointmentDetails = () => {
    return (
      <Paper className={classes.paper}>
        <DialogTitle className={classes.title}>
          Resumen del Vehículo
        </DialogTitle>

        <Table bordered className={classes.tables}>
          <tbody>
            <tr>
              <td className={classes.tableTitle}>ID</td>
              <td>{vehicleData.id ?? '-'}</td>
            </tr>
            <tr>
              <td className={classes.tableTitle}>PLACAS</td>
              <td>{vehicleData.plates ?? '-'}</td>
            </tr>
            <tr>
              <td className={classes.tableTitle}>VIN</td>
              <td>{vehicleData.vin ?? '-'}</td>
            </tr>
            <tr>
              <td className={classes.tableTitle}>MARCA</td>
              <td>{vehicleData.brand ?? '-'}</td>
            </tr>
            <tr>
              <td className={classes.tableTitle}>MODELO</td>
              <td>{vehicleData.model ?? '-'}</td>
            </tr>
            <tr>
              <td className={classes.tableTitle}>AÑO</td>
              <td>{vehicleData.year ?? '-'}</td>
            </tr>
            <tr>
              <td className={classes.tableTitle}>VERSIÓN</td>
              <td>{vehicleData.version ?? '-'}</td>
            </tr>
            <tr>
              <td className={classes.tableTitle}>ESTADO</td>
              <td>{vehicleData.state ?? '-'}</td>
            </tr>
          </tbody>
        </Table>
      </Paper>
    );
  };

  const renderAgencyDetails = () => {
    return (
      <Paper className={classes.paper}>
        <DialogTitle className={classes.title}>Agencia</DialogTitle>
        <Table bordered className={classes.tables}>
          <tbody>
            <tr>
              <td className={classes.tableTitle}>ID</td>
              <td>{agenciesData.id ?? '-'}</td>
            </tr>
            <tr>
              <td className={classes.tableTitle}>KARLO ID</td>
              <td>{agenciesData.karloId ?? '-'}</td>
            </tr>
            <tr>
              <td className={classes.tableTitle}>NOMBRE</td>
              <td>{agenciesData.name ?? '-'}</td>
            </tr>
            {/* <tr>
              <td className={classes.tableTitle}>DIRECCIÓN</td>
              <td>{'-'}</td>
            </tr> */}
            <tr>
              <td className={classes.tableTitle}>TELÉFONO</td>
              <td>{agenciesData.phoneNumber ?? '-'}</td>
            </tr>
            <tr>
              <td className={classes.tableTitle}>EMAIL</td>
              <td>{agenciesData.email ?? '-'}</td>
            </tr>
          </tbody>
        </Table>
      </Paper>
    );
  };

  const renderUserDetails = () => {
    return (
      <Paper className={classes.paper}>
        <DialogTitle className={classes.title}>Cliente</DialogTitle>

        <Table bordered className={classes.tables}>
          <tbody>
            <tr>
              <td className={classes.tableTitle}>ID</td>
              <td>{userData.id ?? '-'}</td>
            </tr>
            <tr>
              <td className={classes.tableTitle}>NOMBRE</td>
              <td>{userData.name ?? '-'}</td>
            </tr>
            <tr>
              <td className={classes.tableTitle}>TELÉFONO CELULAR</td>
              <td>{userData.phoneNumber ?? '-'}</td>
            </tr>
            <tr>
              <td className={classes.tableTitle}>EMAIL</td>
              <td>{userData.email ?? '-'}</td>
            </tr>
            <tr>
              <td className={classes.tableTitle}>GÉNERO</td>
              <td>
                {userData.gender == 'M'
                  ? 'Hombre'
                  : userData.gender == 'F'
                  ? 'Mujer'
                  : '-'}
              </td>
            </tr>
          </tbody>
        </Table>
      </Paper>
    );
  };

  const renderPackageDetails = () => {
    return (
      <Paper className={classes.paper}>
        <DialogTitle className={classes.title}>Paquete</DialogTitle>
        <Table bordered className={classes.tables}>
          <tbody>
            <tr>
              <td className={classes.tableTitle}>NOMBRE</td>
              <td>{'-'}</td>
            </tr>
            <tr>
              <td className={classes.tableTitle}>DESCRIPCIÓN</td>
              <td>{'-'}</td>
            </tr>
            <tr>
              <td className={classes.tableTitle}>PRECIO</td>
              <td>{'-'}</td>
            </tr>
          </tbody>
        </Table>
      </Paper>
    );
  };

  const renderFeedBackModal = () => {
    try {
      const { successModal, errorModal } = vehicleDetail;
      if (
        (successModal &&
          'show' in successModal &&
          successModal.show) ||
        (errorModal && 'show' in errorModal && errorModal.show)
      ) {
        const modalType = successModal.show
          ? 'successModal'
          : errorModal.show
          ? 'errorModal'
          : null;
        const { show, message } = vehicleDetail[modalType];
        return (
          <Modal
            open={show}
            type={modalType}
            closeModal={handleCloseModals}
            dialogTitle={message.title}
            dialogText={message.desc}
            actionButtonText="Aceptar"
            onClick={handleCloseModals}
          />
        );
      }
      return null;
    } catch (e) {
      handleCloseModals();
      return null;
    }
  };

  return (
    <div>
      <Grid container spacing={4}>
        <Grid item xs={12} md={4}>
          {renderAppointmentDetails()}
          {renderUserDetails()}
          {renderFeedBackModal()}
        </Grid>
        <Grid item xs={12} md={8} className={classes.rightContainer}>
          {renderAgencyDetails()}
          <Grid item>
            <ActiviesProgram
              logs={logsData.concat(appointmentsData)}
            />
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}

const mapStateToProps = (state) => ({
  vehicleDetail: makeSelectKarloVehiclesDetails(state),
});

const mapDispatchToProps = {
  getVehicleDetail,
  closeModals: closeModals,
};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(VehicleDetail),
  ),
);
